var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.values.length > 0 || _vm.vs_values.length > 0)?_c('zingchart',{attrs:{"height":_vm.height,"width":_vm.width,"data":_vm.graph_settings,"series":_vm.graph_series}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }